module.exports = __webpack_public_path__ + "img/5.d0b0caa1.jpg";